module.exports = __webpack_public_path__ + "static/media/back.f3a868fd.png";